/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/public/consent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all consents for the authenticated user */
        get: operations["public.consent.get"];
        /** Update or create a player consent */
        put: operations["public.consent.put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/consent/decline-recurring-modal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Decline recurring consent modal */
        post: operations["public.consent.decline_recurring_modal"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/consent/recurring": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get recurring modal consents */
        get: operations["public.consent.get_recurring"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/consent/recurring-switch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Check which recurring modal a user should see */
        get: operations["public.consent.recurring_switch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/consent/should-show-split-consent-text": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns whether the user should be shown the split consent text */
        get: operations["public.consent.should_show_split_consent_text"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/{playerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["v1.consent.player"];
        put?: never;
        post: operations["v1.consent.update_or_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/{playerId}/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["v1.consent.player.single"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/{playerId}/logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Paginated consent change history for one player, newest first */
        get: operations["v1.consent.player.logs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/{playerId}/verification": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Change verification value for a type */
        put: operations["v1.consent.verification"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.consent.batch_get"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/batch/{playerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Updates several consents for a player */
        post: operations["v1.consent.batch_update_or_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/batch/{playerId}/verification": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.consent.batch.verification"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/batch/amount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.consent.amount.batch_get_with_type"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/batch/check-marketing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.consent.batch_check_marketing"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/consent/batch/type/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Update a consent type for a batch of players */
        post: operations["v1.consent.batch_type_update_or_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/correspondenceMarketingConsent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets all CorrespondenceMarketingConsentLinks */
        get: operations["v1.correspondence_marketing_consent_links.index"];
        put?: never;
        /** Creates a new CorrespondenceMarketingConsentLink */
        post: operations["v1.correspondence_marketing_consent_links.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/correspondenceMarketingConsent/{correspondenceMarketingConsent}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets a given CorrespondenceMarketingConsentLink */
        get: operations["v1.correspondence_marketing_consent_links.show"];
        put?: never;
        post?: never;
        /** Deletes a given CorrespondenceMarketingConsentLink */
        delete: operations["v1.correspondence_marketing_consent_links.destroy"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** BatchConsentRequest */
        BatchConsentRequest: {
            /** @description Array of ConsentRequests */
            consents: components["schemas"]["ConsentRequest"][];
        };
        /** BatchConsentTypeRequest */
        BatchConsentTypeRequest: {
            /** @description Array of consentTypeRequests */
            consents: components["schemas"]["ConsentTypeRequest"][];
        };
        /** BatchGetConsentRequest */
        BatchGetConsentRequest: {
            /** @description Array of consent types to fetch */
            consent_types: components["schemas"]["ConsentType"][];
            /** @description Array of player UUIDs (min: 1, max: 1000) */
            player_ids: Record<string, never>[];
        };
        /** BatchPlayerRequest */
        BatchPlayerRequest: {
            /** @description Array of player UUIDs (min: 1, max: 1000) */
            player_ids: Record<string, never>[];
        };
        /** BatchVerificationRequest */
        BatchVerificationRequest: {
            /** @description Array of VerificationRequests */
            consents: components["schemas"]["VerificationRequest"][];
        };
        /**
         * Brand
         * @enum {string}
         */
        Brand: Brand;
        /** ConsentRequest */
        ConsentRequest: {
            /** @description Admin user ID who made the change */
            admin_user_id?: number | null;
            brand?: components["schemas"]["Brand"] | null;
            /** @description Whether the consent has been revoked */
            revoked?: boolean | null;
            /** @description Source of the consent */
            source?: string | null;
            /** @description Text content of the consent */
            text?: string | null;
            /** @description Type of the consent */
            type: components["schemas"]["ConsentType"];
            verification_status?: components["schemas"]["VerificationType"] | null;
            /** @description Version of the consent */
            version: string;
        };
        /**
         * ConsentType
         * @enum {integer}
         */
        ConsentType: ConsentType;
        /** ConsentTypeRequest */
        ConsentTypeRequest: {
            /** @description Admin user ID who made the change */
            admin_user_id?: number | null;
            brand?: components["schemas"]["Brand"] | null;
            /** @description UUID of the player */
            player_id: string;
            /** @description Whether the consent has been revoked */
            revoked?: boolean | null;
            /** @description Source of the consent */
            source?: string | null;
            /** @description Text content of the consent */
            text?: string | null;
            verification_status?: components["schemas"]["VerificationType"] | null;
            /** @description Version of the consent */
            version: string;
        };
        /** CorrespondenceMarketingConsentLink */
        CorrespondenceMarketingConsentLink: {
            admin_user_id: number;
            code: string;
            /** Format: date-time */
            created_at: string | null;
            declines: number;
            email: number;
            id: number;
            sms: number;
            /** Format: date-time */
            updated_at: string | null;
        };
        /** CorrespondenceMarketingConsentLinkRequest */
        CorrespondenceMarketingConsentLinkRequest: {
            /** @description Admin user ID creating the consent link */
            admin_user_id: number;
        };
        /** DeclineRecurringConsentModalRequest */
        DeclineRecurringConsentModalRequest: {
            /** @description Code of the recurring consent modal to decline */
            consent_code?: string | null;
        };
        /** GetPlayerConsentRequest */
        GetPlayerConsentRequest: {
            columns?: GetPlayerConsentRequestColumns[];
            groupBy?: GetPlayerConsentRequestGroupBy[];
            page?: number;
            perPage?: number;
            query?: {
                and?: string[][];
                or?: string[][];
            };
        };
        /** PlayerConsent */
        PlayerConsent: {
            admin_user_id: number | null;
            brand: components["schemas"]["Brand"] | null;
            /** Format: date-time */
            created_at: string | null;
            id: number;
            player_consent_log_id: number;
            player_id: string;
            revoked: number;
            revoked_at: string | null;
            source: string | null;
            type: components["schemas"]["ConsentType"];
            /** Format: date-time */
            updated_at: string | null;
            verification_status: components["schemas"]["VerificationType"];
            version: string;
        };
        /** PublicPlayerConsentObject */
        PublicPlayerConsentObject: {
            /** @description Admin user ID who made the change */
            admin_user_id?: number | null;
            brand?: components["schemas"]["Brand"] | null;
            /** @description Consent code for public player consent */
            consent_code?: string | null;
            /** @description Whether the consent has been revoked */
            revoked?: boolean | null;
            /** @description Source of the consent */
            source?: string | null;
            /** @description Text content of the consent */
            text?: string | null;
            /** @description Type of the consent */
            type: components["schemas"]["ConsentType"];
            verification_status?: components["schemas"]["VerificationType"] | null;
            /** @description Version of the consent */
            version: string;
        };
        /** RecurringConsentModalRequest */
        RecurringConsentModalRequest: {
            /**
             * @description Force showing the recurring consent modal
             * @default false
             */
            forceShow?: boolean;
        };
        /** RecurringConsentModalSwitchResponse */
        RecurringConsentModalSwitchResponse: {
            /** @description Whether to show the simple recurring modal */
            simple_recurring_modal: boolean;
            /** @description Whether to show the split recurring modal */
            split_recurring_modal: boolean;
        };
        /** ShouldShowSplitConsentTextResponse */
        ShouldShowSplitConsentTextResponse: {
            /** @description Whether to show split consent text */
            should_show_split_consent_text: boolean;
        };
        /** VerificationRequest */
        VerificationRequest: {
            brand?: components["schemas"]["Brand"] | null;
            /** @description Source of the verification */
            source?: string | null;
            /** @description Type of the consent to verify */
            type: components["schemas"]["ConsentType"];
            /** @description Verification status to set */
            verification_status: components["schemas"]["VerificationType"];
        };
        /**
         * VerificationType
         * @enum {string}
         */
        VerificationType: VerificationType;
    };
    responses: {
        /** @description Not found */
        ModelNotFoundException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Validation error */
        ValidationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description A detailed description of each field that failed validation. */
                    errors: {
                        [key: string]: string[];
                    };
                    /** @description Errors overview. */
                    message: string;
                };
            };
        };
    };
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    "public.consent.get": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerConsent"][];
                };
            };
        };
    };
    "public.consent.put": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `PublicPlayerConsentObject` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["PublicPlayerConsentObject"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.consent.decline_recurring_modal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `DeclineRecurringConsentModalRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["DeclineRecurringConsentModalRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.consent.get_recurring": {
        parameters: {
            query?: {
                forceShow?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerConsent"][];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "public.consent.recurring_switch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `RecurringConsentModalSwitchResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RecurringConsentModalSwitchResponse"];
                };
            };
        };
    };
    "public.consent.should_show_split_consent_text": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ShouldShowSplitConsentTextResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ShouldShowSplitConsentTextResponse"];
                };
            };
        };
    };
    "v1.consent.player": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerConsent"][];
                };
            };
        };
    };
    "v1.consent.update_or_create": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `ConsentRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConsentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.consent.player.single": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
                type: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
        };
    };
    "v1.consent.player.logs": {
        parameters: {
            query?: {
                from?: string | null;
                page?: number | null;
                perPage?: number | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: string;
                        meta: {
                            current_page: string;
                            next_page_url: string;
                            per_page: string;
                        };
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.consent.verification": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `VerificationRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerificationRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.consent.batch_get": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `BatchGetConsentRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchGetConsentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.consent.batch_update_or_create": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `BatchConsentRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchConsentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.consent.batch.verification": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `BatchVerificationRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchVerificationRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.consent.amount.batch_get_with_type": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["GetPlayerConsentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["PlayerConsent"][];
                        meta: {
                            current_page: number;
                            next_page_url: string | null;
                            per_page: number;
                        };
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.consent.batch_check_marketing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `BatchPlayerRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchPlayerRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.consent.batch_type_update_or_create": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: number;
            };
            cookie?: never;
        };
        /** @description `BatchConsentTypeRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchConsentTypeRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.correspondence_marketing_consent_links.index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CorrespondenceMarketingConsentLink"][];
                };
            };
        };
    };
    "v1.correspondence_marketing_consent_links.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `CorrespondenceMarketingConsentLinkRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CorrespondenceMarketingConsentLinkRequest"];
            };
        };
        responses: {
            /** @description `CorrespondenceMarketingConsentLink` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CorrespondenceMarketingConsentLink"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.correspondence_marketing_consent_links.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The correspondence marketing consent ID */
                correspondenceMarketingConsent: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `CorrespondenceMarketingConsentLink` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CorrespondenceMarketingConsentLink"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.correspondence_marketing_consent_links.destroy": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The correspondence marketing consent ID */
                correspondenceMarketingConsent: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
}
export enum Brand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum ConsentType {
    Value1 = 1,
    Value2 = 2,
    Value3 = 3,
    Value4 = 4,
    Value5 = 5,
    Value6 = 6,
    Value7 = 7,
    Value8 = 8,
    Value9 = 9
}
export enum GetPlayerConsentRequestColumns {
    id = "id",
    player_consent_log_id = "player_consent_log_id",
    player_id = "player_id",
    type = "type",
    version = "version",
    revoked = "revoked",
    revoked_at = "revoked_at",
    created_at = "created_at",
    updated_at = "updated_at",
    verification_status = "verification_status",
    source = "source",
    admin_user_id = "admin_user_id",
    brand = "brand",
    and = "and",
    or = "or"
}
export enum GetPlayerConsentRequestGroupBy {
    id = "id",
    player_consent_log_id = "player_consent_log_id",
    player_id = "player_id",
    type = "type",
    version = "version",
    revoked = "revoked",
    revoked_at = "revoked_at",
    created_at = "created_at",
    updated_at = "updated_at",
    verification_status = "verification_status",
    source = "source",
    admin_user_id = "admin_user_id",
    brand = "brand",
    and = "and",
    or = "or"
}
export enum VerificationType {
    UNVERIFIED = "UNVERIFIED",
    PENDING = "PENDING",
    VERIFIED = "VERIFIED",
    DECLINED = "DECLINED",
    REVOKED = "REVOKED",
    ACCEPTED = "ACCEPTED"
}
